// extracted by mini-css-extract-plugin
export default {"timerTime":"timer_timerTime__zh-Cv","time":"timer_time__o4u9F"};